export default "__VITE_ASSET__DwlvBNHn__"